import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32 0H0V32H32V0Z",
      class: "bg",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.0401 8.31491L15.4907 7.66914C13.2263 6.68699 10.5512 6.75529 8.33899 8.07847C8.11504 8.21242 7.99418 8.45494 8.00321 8.7003C8.00109 8.72248 8 8.74497 8 8.76771V25.3078C8 25.6901 8.30695 26 8.68559 26C9.06423 26 9.37118 25.6901 9.37118 25.3078V20.0961C11.1135 19.1996 13.2189 19.1951 15.0206 19.9856L16.4773 20.6671L16.4916 20.6736C18.7836 21.6823 21.4519 21.5971 23.6639 20.2741C23.8722 20.1495 24 19.9231 24 19.6786V8.63991C24 8.39123 23.8679 8.16166 23.6539 8.03854C23.4399 7.91541 23.1769 7.91765 22.965 8.0444C21.1633 9.12203 18.9751 9.16634 17.0524 8.3202L17.0401 8.31491Z",
      class: "primary",
      fill: "#151F6D"
    }, null, -1)
  ])))
}
export default { render: render }